import { useMutation } from 'react-query';
import { getApi } from '../config/SwaggerApi';

const useLogOutMutationFn = () =>
    getApi()
        .user.userLogoutPost()
        .then((res) => res.data);

const useLogOutMutation = () => {
    const groupMutation = useMutation(useLogOutMutationFn);
    return groupMutation;
};

export default useLogOutMutation;
